<template>
  <div class="text-sm">
    <!-- the heading of in teal -->
    <div class="headBar p-6 text-white mb-2">
      <div class="text-3xl font-bold">Gestion des profils</div>
    </div>

    <collapse-item id="parent">
      <div slot="leading">
        <i class="fas fa-gift mr-4"></i>Profils des parents
      </div>
      <profile-parents class="p-2 p-lg-4" slot="component"></profile-parents>
    </collapse-item>

    <collapse-item id="student">
      <div slot="leading">
        <i class="fas fa-graduation-cap mr-4"></i>Profils des éleves
      </div>
      <profile-eleves class="p-2 p-lg-4" slot="component"></profile-eleves>
    </collapse-item>

    <collapse-item id="offer">
      <div slot="leading">
        <i class="fab fa-audible mr-4"></i>Abonnement
      </div>
      <abonnement class="p-2 p-lg-4" slot="component"></abonnement>
    </collapse-item>
  </div>
</template>

<script>
import collapseItem from "../components/CollapseItem";
import ProfileParents from "../components/collapsable_container/components/profileParents";
import ProfileEleves from "../components/collapsable_container/components/profileEleve";
import Abonnement from "../components/collapsable_container/components/Abonnement";

export default {
  data() {
    return {
      stateData: [false, false, false],
    };
  },
  components: {
    "collapse-item": collapseItem,
    "profile-parents": ProfileParents,
    "profile-eleves": ProfileEleves,
    abonnement: Abonnement,
  },
  watch: {
    "$route.query.section"(val) {
      this.$root.$emit('bv::toggle::collapse', val)
    }
  },
  methods: {},
  mounted() {
    this.$root.$emit('bv::toggle::collapse', this.$route.query.section)
  }
};
</script>

<style scoped>
.headBar {
  background: rgb(0, 87, 85);
  background: linear-gradient(
    90deg,
    rgba(0, 87, 85, 1) 0%,
    rgba(0, 169, 164, 1) 44%
  );
}
</style>
